import React, {useState} from 'react'
import { Col, Card, Form, Button } from 'react-bootstrap'
import { FaCheckCircle } from 'react-icons/fa';
import { Link, useOutletContext } from 'react-router-dom'
import { ASSET_URL } from './../../constant';
import { ADD_TO_CART } from '../../helpers';
import {  MySpinner } from '../index';

const CardProductCollapse = (props) => {
    const { getCountCart } = useOutletContext();

    const [Qty, setQty] = useState('')
    const [Load, setLoad] = useState(false)

    // use Default Categories Photo
    const mainImage = JSON.parse(props.data.image)[0].url != "images/default-image-products.jpg" ?
        JSON.parse(props.data.image)[0].url :
        JSON.parse(props.data.category.thumbnail)[0].url;

    const addToCart = async (e) => {
        e.preventDefault();

        setLoad(true)
        await ADD_TO_CART(e, props.data.id, Qty)
        .then((res) => {
            setQty('')
            setLoad(false)
            getCountCart()
        })
    }

    return (
        <>
        {props.data && 
            <Col lg={4} md={6} sm={12} className="my-4">
                {Load && <MySpinner />}
                <Card className="border rounded-0 product-home-card">
                    {props.data.discount && <div className="discount" data-discount={`-`+props.data.discount+`% OFF`} /> }
                    <Link to={'/products/'+ props.data.item_no} className="text-dark">
                        <Card.Body>
                            <div className="product-image">
                                <Card.Img variant="top" src={ASSET_URL + mainImage} className="rounded-0" alt={props.data.manufacture_no} />
                            </div>
                            <div className="product-detail">
                                <div className="product-name">
                                    <p className="fs-5 m-0 fw-bold text-uppercase">{props.data.name}</p>
                                    <p className="fs-6 fw-bold text-secondary text-uppercase">{props.data.brand && props.data.brand.name}</p>
                                </div>
                                <div className="product-desc" dangerouslySetInnerHTML={{__html: props.data.description}} />
                                <div className="product-item">
                                    <p className="text-secondary text-uppercase"><span className="fw-bold">MI ITEM #</span> {props.data.item_no}</p>
                                </div>
                                <div className="product-stock">
                                    <p>
                                        <FaCheckCircle className="fs-5 text-success" />
                                    </p>
                                    <p className="small">
                                        <b>Quote</b> <br />
                                        For Your Price & Availability Stock
                                    </p>
                                </div>
                            </div>
                        </Card.Body>
                    </Link>
                    <div className="product-cart">
                        <span className="fs-5 fw-bold">Qty</span>
                        <Form>
                            <Form.Group className="input-group">
                                <Form.Control type="number"
                                    name="qty"
                                    autoComplete="off"
                                    value={Qty}
                                    onChange={(e) => setQty(e.target.value)}
                                />
                                <Button variant="info" type="button" onClick={(e) => addToCart(e)}>
                                    Add to Quote
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Card>
            </Col>
        }
        </>
    )
}

export default CardProductCollapse
